import TikTok from "./TikTok"

function Feed(props){
  console.log({ props })
  console.table(props.tiktoks)
  
  const {tiktoks} = props
  return(
    <div id="Feed" className="col-10">
      {tiktoks.map((t,i) =>(
        <TikTok key={i} tiktok = {t}/>
      ))}
    </div>

  )

}
export default Feed